export default __webpack_public_path__ + "static/media/google_gray.80be9483.svg";